import { styled, TextField } from "@mui/material";

export const StyledTextField = styled(TextField)(({ theme: { palette } }) => ({
  "& .MuiInputBase-input": {
    textDecoration: "underline",
    color: palette.text.secondary,
  },
}));
